import axios from 'axios'
import services from './services'
import interceptors from './interceptors'

// Production
// const baseURL = 'https://api.sambamaniacos.com.br'
//
// Homolog
const baseURL = 'http://localhost:8000'

// Criando uma instância de Axios
const instance = axios.create({
    baseURL: baseURL
})

// Adicionando interceptros a instância
instance.interceptors.request.use(interceptors)

// Adicionando os métodos de serviços
Object.keys(services).map(service => {
    Object.keys(services[service]).map(action => {
        const actions = services[service][action]
        services[service][action] = data => {
            return axios({
                ...actions,
                data: data,
                baseURL: baseURL
            })
        }
    })
})

// Adiciona o token no header
const setBearerToken = token => {
    instance.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

export default services
export { instance, setBearerToken, baseURL }
